import { useGetMusicsApiV1Suspense } from "@/api/__generated__/api.schema.ts";
import { useSearchParams } from "react-router";
import { useMusicFilter } from "../components/music-mood-filter";

// NOTE: Since there aren't many music, we fetch all of them at once. Later, if the number increases, we'll update it to use infinite scroll.
export const COUNT_PER_PAGE = 100;

interface UseMusicsOptions {
  favorite?: boolean;
}

export function useMusics(options?: UseMusicsOptions) {
  const { currentMoods } = useMusicFilter();
  const isFavorite = useIsFavorite();

  const {
    data: {
      data: { items: musics },
    },
  } = useGetMusicsApiV1Suspense({
    limit: COUNT_PER_PAGE,
    moods: currentMoods?.join(","),
    isFavorite: options?.favorite ?? isFavorite,
  });

  return { data: musics };
}

export function useIsFavorite() {
  const [searchParams] = useSearchParams();
  const isFavorite = Boolean(searchParams.get("favorite") === "true");

  return isFavorite;
}
